/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import '@neo4j-ndl/base/lib/neo4j-ds-styles.css';

import { Breadcrumbs, Menu } from '@neo4j-ndl/react';
import {
  BuildingOffice2IconOutline,
  FolderIconOutline,
  Neo4JIconColorIcon,
} from '@neo4j-ndl/react/icons';
import { useRef, useState } from 'react';

const Component = () => {
  const [isOrganizationMenuOpen, setIsOrganizationMenuOpen] = useState(false);
  const organizationMenuRef = useRef<HTMLButtonElement>(null);

  return (
    <Breadcrumbs shouldWrap={false}>
      <Breadcrumbs.Item className="n-mr-token-8">
        <button
          type="button"
          aria-label="Home"
          className="n-rounded-sm focus-visible:n-outline-2 focus-visible:n-outline-offset-[3px] focus-visible:n-outline-primary-focus n-shrink-0"
        >
          <Neo4JIconColorIcon className="n-h-6 n-w-[26px]" />
        </button>
      </Breadcrumbs.Item>
      <Breadcrumbs.Item>
        <Breadcrumbs.Button leadingElement={<BuildingOffice2IconOutline />}>
          Organization 1
        </Breadcrumbs.Button>
        <Breadcrumbs.SelectButton
          ref={organizationMenuRef}
          ariaLabel="Open organization menu"
          onClick={() => {
            setIsOrganizationMenuOpen((prev) => !prev);
          }}
          isActive={isOrganizationMenuOpen}
        >
          <Menu
            anchorRef={organizationMenuRef}
            isOpen={isOrganizationMenuOpen}
            onClose={() => setIsOrganizationMenuOpen(false)}
          >
            <Menu.Group>
              <Menu.RadioItem title="Organization 1" isChecked={true} />
              <Menu.RadioItem title="Organization 2" isChecked={false} />
            </Menu.Group>
            <Menu.Divider />
            <Menu.Group>
              <Menu.Item title="All Organizations" />
            </Menu.Group>
          </Menu>
        </Breadcrumbs.SelectButton>
      </Breadcrumbs.Item>
      <Breadcrumbs.Item>
        <Breadcrumbs.Button leadingElement={<FolderIconOutline />}>
          Project 1
        </Breadcrumbs.Button>
        <Breadcrumbs.SelectButton ariaLabel="Open project menu"></Breadcrumbs.SelectButton>
      </Breadcrumbs.Item>
    </Breadcrumbs>
  );
};

export default Component;
